module.exports = __webpack_public_path__ + "static/media/BarmanSmall.a724f66e.jpg";